export default "/kiban/_next/static/images/black-075bebd6904ff447552bfbe0ddba323e.png";